import React, { useState } from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import './Add_Complaint.css'
import moment from 'moment';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

export default function Payment_Complaint({complaintDetails, setComplaintDetails, isSubmitting,}) {
const locate = useLocation();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const staffId = useSelector((state) => state.id);
      const complaintId = complaintDetails?._id; // 👈 extract it safely

const[isOpenPayment ,setIsOpenPayment] =useState(false);
    const createdDate = complaintDetails.createdDate; // ISO string from backend
const daysAgo = moment().diff(moment(createdDate), 'days');


function formatDateToDDMMYYYY(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

  const [customerdelete, setcustomerdelete] = useState(false);




      const installationId = complaintDetails?._id; // 👈 extract it safely
  const staffName = useSelector((state) => state.staffname);

  
 const [originalData, setOriginalData] = useState({});

  const [paymentData, setPaymentData] = useState({
    payType: "",
    payAmount: "",
    referenceNumber: "",
    updatedBy: staffName, // or set from login user
    updatedTime: new Date().toLocaleTimeString(),
    updatedDate: new Date().toLocaleDateString(),
  });

  const[isOpenThreeDots,setIsOpenThreeDots]=useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
 
  const handleFileChange = (e) => {
   const files = Array.from(e.target.files); // make sure it's always an array
   setSelectedFile(files);
   console.log("Selected files:", files);
 };
 



const handleSubmit = async (e) => {
  e.preventDefault();

  const result = await Swal.fire({
    title: "Do you want to save the Payment Details?",
    showCancelButton: true,
    confirmButtonText: "Save",
  });

  if (!result.isConfirmed) return;

  try {
    // ✅ Validation
    if (!paymentData.payType || !paymentData.payAmount || !paymentData.referenceNumber) {
      return Swal.fire("Missing fields", "Please fill all required payment fields", "warning");
    }
    if (isNaN(Number(paymentData.payAmount))) {
      return Swal.fire("Invalid Amount", "Pay Amount must be a number", "warning");
    }

    // 1️⃣ Append to payment.items but keep payment.images intact
    const existingItems = complaintDetails?.payment?.items || [];
    const existingImages = complaintDetails?.payment?.images || [];
    
    // Calculate new total paid
    const newItems = [
      ...existingItems,
      {
        ...paymentData,
        payAmount: Number(paymentData.payAmount),
        updatedBy: staffName,
        updatedTime: new Date().toLocaleTimeString(),
        updatedDate: new Date().toLocaleDateString(),
      },
    ];

    const totalPaid = newItems.reduce((acc, item) => acc + (Number(item.payAmount) || 0), 0);
    const totalCharge = Number(complaintDetails?.complaintadditionalCharges) || 0;
    const isCompleted = totalPaid >= totalCharge;

    const fullPayment = {
      isCompleted: isCompleted,
      items: newItems,
      images: existingImages, // preserve old images
    };

    // --- Save payment and get updated document ---
    const paymentRes = await axios.post(
      `${apiUrl}/update-lead-complaint`,
      {
        leadId: complaintDetails.leadId,
        payment: fullPayment,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    let updatedDetails = paymentRes.data.updatedDocument || complaintDetails;

    // 2️⃣ Upload Images (append to payment.images)
    if (selectedFile && selectedFile.length > 0) {
      const formData = new FormData();
      formData.append("type", "complaint");
      formData.append("id", complaintId);
      formData.append("staffId", staffId);
      formData.append("staffName", staffName);

      selectedFile.forEach((file) => {
        if (file instanceof File) {
          formData.append("images", file);
        }
      });

      const imageRes = await axios.post(`${apiUrl}/payment/images/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // If backend returns updated doc after image upload, replace details
      if (imageRes.data.updatedDocument) {
        updatedDetails = imageRes.data.updatedDocument;
      }
    }

    // ✅ Update local state so UI reflects latest changes
    setComplaintDetails(updatedDetails);

    Swal.fire("Success!", "Payment and images saved successfully", "success");

    // Reset form
    setPaymentData({
      payType: "",
      payAmount: "",
      referenceNumber: "",
      updatedBy: "",
      updatedTime: "",
      updatedDate: "",
    });
    setSelectedFile([]);
    setIsOpenPayment(false);

  } catch (error) {
    console.error("Submit Error:", error);
    Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
  }
};


    const handleChange = (e) => {
        const { name, value } = e.target;
        setPaymentData(prev => ({
          ...prev,
          [name]: value
        }));
      };


  
const formatDatecreate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

 const isPaymentAvailable = complaintDetails?.payment?.items.length > 0;

  
  return (
    <div>
        <Container>
            <form>
                <Row>
                    <Col md={9} sm={19} >
          <div className='plan-details-container-border-complaint mt-5 text-center ms-5' style={{width:"80%"}}>
  <p  style={{ fontSize:"13px"}}className='mt-3'>
    {/* <span className='text-primary'>Network</span> */}
     Complaint - <span className='text-primary'>{complaintDetails?.complaintType}</span> Customer Affected - <span className='text-primary'>{complaintDetails?.complaintcustomerAffected} @ </span>Location - <span className='text-primary'>{complaintDetails?.complaintlocation}</span></p>                         
   <p style={{ fontSize:"13px"}}  class="mb-3"> Complaint Open Date - <span className='text-primary'>{formatDatecreate(complaintDetails?.createdDate)} , </span> Complaint Open Last - <span className='text-primary'>{daysAgo} Days</span></p>                         
   </div>
    </Col >
    {/* <Col  md={3} sm={3} className='text-start'>
    <div className='text-start ' >
     <button type="button" className='add-payment bg-warning' onClick={()=>setIsOpenPayment(true)}> Add Payment</button>

    
    </div>
    
    </Col> */}
    </Row>


   {!isPaymentAvailable && (
     <div className='modal-payment1 mt-5'>
                  <Container>
                      <div>
  
                      <Row className='mb-3'>
                          <Col className=''> <h5>Pay</h5></Col>
                          {/* <Col className='text-end'><span style={{fontSize:"23px"}} onClick={()=>setIsOpenPayment(false)}><strong>&times;</strong>   </span> </Col> */}
                      </Row>
                      <Row>
                          <Col>
                          <div>
                          <label className='text-start'>
                              <p>Pay Type</p>
                          </label>
                          <br/>
                          <select
                                                                              
                                                                              class=" form-input-select payment-select-option mt-2 "
                                                                              value={paymentData.payType}
                                                                              name="payType"
                                                                              onChange={handleChange}
                                                                          >
                                                                              <option value="">Select Type</option>
                                                                              <option
                                                                                  
                                 
                                                                                  value="Private"
                                                                              >
                                                                                  Private
                                                                              </option>
                                                                              <option  value="Technology">
                                                                                  Technology
                                                                              </option>
                                                                              <option  value="Cash">
                                                                                  cash
                                                                              </option>
                                                                              <option  value="Helpdesk">
                                                                                  Helpdesk
                                                                              </option>
                                                                              <option  value="Others">
                                                                              Others
                                                                              </option>
                                                                          </select>
                                                                          </div>
                          </Col>
  
                          <Col>
                          <div >
                              <label>Pay Amount</label>
                              {/* <br/> */}
                              <input  className='form-input'
                              placeholder='Rs.'  value={paymentData.payAmount}
                              onChange={handleChange}
                              name="payAmount"/>
                             
                          </div>
                          </Col>
                      </Row>
                      <Row>
                          <label>Reference Number</label>
                          <br/>
                          <input className='form-input  payment-reference' placeholder='Enter Reference Number' type="text"
                          value={paymentData.referenceNumber}
                          onChange={handleChange}
                          name="referenceNumber"/>
                      </Row>
                      <Row>
                      <input
                      type="file"
                      // variant="light"
                      onChange={handleFileChange}
 
                      className="btn-upload   file-upload form-input payment-reference "
                      style={{ height: "45px" }}
                      placeholder='upload file'
                      
                      
                    />
                      </Row>
                      <div className='text-end'>
  
                      <button  type="button" className='blue-btn' onClick={handleSubmit} > Submit</button>
                      </div>
  
                      </div>
                  
                  </Container>
              </div>
     )}
     
  
      
  
  
  
  
     {complaintDetails?.payment?.items.length > 0 && (
    <>
      {/* Add Payment Button */}
      <div className='add-payment-intall'>
        <Row>
        <Col md={3} sm={3} className="text-end">
          <div className="text-end " >
            <button
              type="button"
              className="add-payment-install bg-warning"
              onClick={() => setIsOpenPayment(true)}
            >
              Add Payment
            </button>
  
            {/* Modal */}
            {isOpenPayment && (
              <div className="overlay-payment">
                <div className="modal-payment">
                  <Container>
                    <Row>
                      <Col className='text-start'>
                        <h5>Pay</h5>
                      </Col>
                      <Col className="text-end">
                        <span
                          style={{ fontSize: "23px" }}
                          onClick={() => setIsOpenPayment(false)}
                        >
                          <strong>&times;</strong>
                        </span>
                      </Col>
                    </Row>
  
                    <Row className='text-start'>
                      <Col>
                        <div>
                          <label className="text-start">
                            <p>Pay Type</p>
                          </label>
                          <select className="form-input-select payment-select-option mt-2"
                          value={paymentData.payType}
                          name="payType"
                          onChange={handleChange}>
                            <option value="">Select Type</option>
                            <option value="Private">Private</option>
                            <option value="Technology">Technology</option>
                            <option value="Cash">Cash</option>
                            <option value="Helpdesk">Helpdesk</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </Col>
  
                      <Col>
                        <div>
                          <label>Pay Amount</label>
                          <input className="form-input" placeholder="Rs."
                          value={paymentData.payAmount}
                          name="payAmount"
                          onChange={handleChange} />
                        </div>
                      </Col>
                    </Row>
  
                    <Row className='text-start'>
                      <label>Reference Number</label>
                      <input
                        className="form-input payment-reference"
                        placeholder="Enter Reference Number"
                        type="text"
                        value={paymentData.referenceNumber}
                          name="referenceNumber"
                         onChange={handleChange}
                      />
                    </Row>
  
                    <Row>
                      <input
                        type="file"
                        className="btn-upload file-upload form-input payment-reference"
                        style={{ height: "45px" }}
                                            onChange={handleFileChange}
 
                      />
                    </Row>
                    <div className='text-end'>
  
  <button  type="button" className='blue-btn' onClick={handleSubmit} > Submit</button>
  </div>
  
  
                    
                  </Container>
                </div>
              </div>
            )}
          </div>
         
        </Col>
        </Row>
      </div>
  
      {/* Order Info */}
      {/* <div className="text-center mt-5">
        <p>
          Order Value @ <span>Rs.
           {orderValue}
           /-</span> , Order Score @{" "}
          <span className="green-ruppes-payment">Rs. 26,000/-</span>
        </p>
      </div> */}
  
      {/* Payment Table */}
      <div className="mt-5">
        <table className="table table-bordered">
          <thead className="table-th text-center">
            <tr>
              <th className="table-th-content">Sl.No</th>
              <th className="table-th-content">Date</th>
              <th className="table-th-content">Type</th>
              <th className="table-th-content">Reference No</th>
              <th className="table-th-content">Amount</th>
              {/* <th className="table-th-content">Delete</th> */}
            </tr>
          </thead>
          <tbody>
            {complaintDetails.payment.items.map((pay, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{pay.updatedDate}</td>
                <td>{pay.payType}</td>
                <td>{pay.referenceNumber}</td>
                <td>Rs. {pay.payAmount}</td>
                {/* <td
                  className="text-center"
                  onClick={() => handleDelete(installationId, pay.referenceNumber)}
                >
                  <MdDelete size={20} />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
  
        {/* Due Amount */}
        {/* <div className="due-amount-container">
          <span className="due-label">Due Amount</span>
        </div> */}
      </div>
  
      {/* Transaction Photos */}
         <div className="payment-photo-container">
       <label className="mt-4 ms-5">
         <strong>Transaction Photos ({complaintDetails?.payment?.images?.length || 0})</strong>
       </label>
     
       <Row className="ms-5 me-5">
         {complaintDetails?.payment?.images?.map((img, index) => (
     
           
           <Col key={index} xs={6} md={4} lg={3} className='px-4'>
             {/* Image */}
             <Row className="mt-4 ">
               <img
                 src={img.image}
                 alt={`Payment-${index}`}
                 style={{
                   width: "100%",
                   height: "150px",
                   objectFit: "cover",
                   borderRadius: "8px",
                   border: "1px solid #ddd",
                 }}
               />
             </Row>
     
             {/* Info */}
             <Row>
               <p style={{ fontSize: "10px", marginTop: "5px",textAlign:"center" }}>
                 By <span className="text-primary">{img.staffName}</span>{" "}
                 <span>
                   {formatDateToDDMMYYYY(img.uploadedDate)}
                 </span>
               </p>
             </Row>
           </Col>
         ))}
       </Row>
     </div>
    </>
  )}
  
             </form>
         </Container>
     </div>
   )
 }
